import { useTranslate } from '@/i18n/useTranslate'

interface FooterProps {
    isWelcome?: boolean
}

const Footer = ({ isWelcome = false }: FooterProps) => {
    const { t } = useTranslate()

    return (
        <footer className={`footer ${isWelcome ? 'footer--welcome' : ''}`}>
            {t('footer.voucherSupportPrefix')}
            <span>{t('footer.voucherSupportPhone')}</span>
        </footer>
    )
}

export default Footer
